import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import moment from "moment";
import Grid from "@material-ui/core/Grid";

import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";
import {
  defaultNotifications,
  notificationImages,
} from "../../Utils/Constants";

const EmailNotification = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [notifications, setNotifications] = useState([]);
  const history = useHistory();
  const location = useLocation();

  const loadUser = (brand) => {
    Firebase.getBrandDataByID(brand, (brand_data) => {
      if (brand_data) {
        setBrandData(brand_data);
        loadNotifications(brand_data.name);
      }
    });
  };

  const loadNotifications = (brand_name) => {
    Firebase.getAllNotifications(brand_name, (data) => {
      let initialNotifications = data;
      defaultNotifications.forEach((notification) => {
        if (data.find((item) => item.name === notification.name)) {
          return;
        }
        initialNotifications.push(notification);
      });
      console.log("notifications:", initialNotifications);
      setNotifications(initialNotifications);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setLoading(true);
      setUserName(username);
      loadUser(brand);
    }
  }, [location]);

  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
      />
      <div className="notifications-content">
        <div className="table-header">
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={1}>
              <p>Item</p>
            </Grid>
            <Grid item xs={3}>
              <p>Notification</p>
            </Grid>
            <Grid item xs={3}>
              <p>Admin type</p>
            </Grid>
            <Grid item xs={3}>
              <p>Total number of notifications</p>
            </Grid>
            <Grid item xs={2}>
              <p>Last notification sent</p>
            </Grid>
          </Grid>
        </div>
        {notifications.map((notification) => (
          <div className="table-content" key={notification.name}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={1}>
                {notificationImages[notification.name] && (
                  <img
                    className="notification-img"
                    src={notificationImages[notification.name]}
                    alt={notification.name}
                  />
                )}
              </Grid>
              <Grid item xs={3}>
                <p>{notification.name}</p>
              </Grid>
              <Grid item xs={3}>
                <p>{notification.admin_type}</p>
              </Grid>
              <Grid item xs={3}>
                <p>{notification.count}</p>
              </Grid>
              <Grid item xs={2}>
                <p>
                  {notification.lastEvent
                    ? moment(notification.lastEvent).format("h:mma MM.DD.YYYY")
                    : ""}
                </p>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailNotification;



// WEBPACK FOOTER //
// ./src/screens/EmailNotification/index.js